import { useTranslation } from "react-i18next";

const FILTERS = ["all", "customized", "off"];

export const FilterPills = ({ filter, counts, onChange }) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-wrap gap-1.5"
      role="group"
      aria-label={t("pages.settings.signalsPlaybooks.filters.groupLabel")}
    >
      {FILTERS.map((key) => {
        const active = filter === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            aria-pressed={active}
            className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${
              active
                ? "border-gray-900 bg-gray-900 text-white"
                : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
            }`}
          >
            {t(`pages.settings.signalsPlaybooks.filters.${key}`)}
            <span className={active ? "text-white/60" : "text-gray-400"}>
              {counts[key] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
};
